
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FclistdataComponent } from './fclistdata.component';
import { FctlblistitemComponent } from '../fctlb/fctlblistitem.component';
import { FcbasicModule } from '../fcbasic/index.module';
import { FclistmodalComponent } from './fclistmodal.component';
import { FctlbModule } from '../fctlb/index.module';
import { FcshareModule } from '../fcshare.modal';
import { AgGridModule } from 'ag-grid-angular';
@NgModule({
  imports: [
    FcshareModule,
    FcbasicModule,
    FctlbModule,
    AgGridModule.withComponents([FctlblistitemComponent])
  ],
  exports: [
    FclistdataComponent,
    FclistmodalComponent
  ],
  declarations: [
    FclistdataComponent,
    FclistmodalComponent
  ],
  entryComponents: [
    FclistdataComponent,
    FclistmodalComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class FclistModule { }
